export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_FAIL = "FETCH_USER_FAIL";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const SHOW_USER_SUCCESS = "SHOW_USER_SUCCESS";
export const SHOW_USER_REQUEST = "SHOW_USER_REQUEST";
export const SHOW_USER_FAIL = "SHOW_USER_FAIL";

export const FETCH_USER_AUTH_SUCCESS = "FETCH_USER_AUTH_SUCCESS";
export const FETCH_USER_AUTH_REQUEST = "FETCH_USER_AUTH_REQUEST";
export const FETCH_USER_AUTH_FAIL = "FETCH_USER_AUTH_FAIL";

export const CHANGE_USER_PASSWORD_REQUEST = "CHANGE_USER_PASSWORD_REQUEST";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL";

export const UPDATE_EMAIL_USER_REQUEST = "UPDATE_EMAIL_USER_REQUEST";
export const UPDATE_EMAIL_USER_SUCCESS = "UPDATE_EMAIL_USER_SUCCESS";
export const UPDATE_EMAIL_USER_FAIL = "UPDATE_EMAIL_USER_FAIL";



export const PROFILE_USER_REQUEST = "PROFILE_USER_REQUEST";
export const PROFILE_USER_SUCCESS = "PROFILE_USER_SUCCESS";
export const PROFILE_USER_FAIL = "PROFILE_USER_FAIL";

export const FETCH_USER_CV_REQUEST = "FETCH_USER_CV_REQUEST";
export const FETCH_USER_CV_SUCCESS = "FETCH_USER_CV_SUCCESS";
export const FETCH_USER_CV_FAIL = "FETCH_USER_CV_FAIL";
